import React from 'react';
import { BaseComponent } from '@platform/template';
import { TabsControl, DragWidthCom } from '@platform/base';
import useCreateDragWidthCom from './store';
import classNames from 'classnames';
require('./createDragWidthCom.less');

const defaultProps = {
    prefixCls: 'drag-width-component',
    expandFlag: true,
    maxFlag: false,
    tabActiveIndex: 0,
};

class CreateDragWidthCom extends BaseComponent {
    constructor(props) {
        super(props);
        const { store, id, config } = props;
        let { defaultWidth = '300px', expandFlag = true, tabActiveIndex = 0 } = config;
        store.setStore('name', id, false);
        store.setStore(['expandFlag'], expandFlag, false);
        store.setStore(["domWidth"], defaultWidth, false);
        store.setStore(["tabActiveIndex"], tabActiveIndex, true);
    }

    onChangeFun = activeIndex => {
        const { store } = this.props;
        store.setTabActiveIndex({ tabActiveIndex: activeIndex });
    }

    onDragMove = domWidth => {
        let { store, pageScope, config } = this.props;
        let { formId = [] } = config;
        let formIdArr = Array.isArray(formId) ? formId : [formId];
        store.setDomWidth({
            width: domWidth,
            shouldForceUpdate: false,
        });
        if (formIdArr.length) {
            formIdArr.forEach(formId => pageScope?.form?.resetItemWidth(formId));
        }
    };

    onExpand = expandFlag => {
        let { store, pageScope, config } = this.props;
        let { formId = [] } = config;
        let formIdArr = Array.isArray(formId) ? formId : [formId];
        store.setExpandFlag({
            expandFlag,
            shouldForceUpdate: false,
        });
        // dragWidthCom 组件里使用了flex布局和transition动画，需要等待动画结束form才能获取到真正的宽度，才能进行自适应宽度计算
        // .clickWidthCom_transition 类名是这个，如果后期动画时间调整，可能会影响这里
        setTimeout(() => {
            if (formIdArr.length) {
                formIdArr.forEach(formId => pageScope?.form?.resetItemWidth(formId));
            }
        }, 300);
    };

    getTabContent(list, tabActiveIndex, maxFlag) {
        if (!list || !list.length) {
            return;
        }
        let TabPaneList = list.map((item, index) => <div className={classNames({ "lightapp-component-TabContent": true, "lightapp-component-TabContent-active": index === tabActiveIndex })} key={item.key}>{item.value}</div>);
        let tabsControlList = list.map((item, index) => <div key={item.key} clickFun={this.onChangeFun.bind(this, index)}>
            {item.icon ? <i className={classNames({ iconfont: true, [item.icon]: true })} /> : null}
            {item.title}
        </div>);
        return (
            <div className={classNames({
                dragWidthComTabs: true,
                // NCC-150605 侧边抽屉-抽屉顶部的页签只有一个的时候也保留
                // dragWidthComTabsMax: maxFlag || list.length === 1,
                dragWidthComTabsMax: maxFlag,
            })}>
                {/* 最大化情况下不展示tabs */}
                <TabsControl
                    defaultKey={tabActiveIndex}
                    type="card"
                    className="dragWidthComTabs_tabs"
                >
                    {tabsControlList}
                </TabsControl>
                {TabPaneList}
            </div>);
    }

    render() {
        let { config = {}, store, id } = this.props;
        let {
            defaultWidth = '350px',
            minWidth = '50px',
            aside = 'left',
            leftDom,
            rightDom,
            tabContent,
            showExpandBtn = true,
            tabActiveIndex,
            ...others
        } = config;
        let {
            getExpandFlag,
            getMaxFlag,
            getTabActiveIndex,
            getDomWidth,
        } = store;

        let activeIndex = getTabActiveIndex();
        let max = getMaxFlag();
        let tabsDomWidth = getDomWidth();
        let TabList = this.getTabContent(tabContent, activeIndex, max);
        let expand = getExpandFlag();
        aside === "left" ? leftDom = TabList || leftDom : rightDom = TabList || rightDom;
        // let expandFlag = store.getStore('expandFlag');
        // 剩余的项，未满一行的项
        return <DragWidthCom
            {...others}
            id={id}
            defLeftWid={tabsDomWidth || defaultWidth}
            leftMinWid={minWidth}
            aside={aside}
            leftDom={leftDom}
            rightDom={rightDom}
            tabActiveIndex={activeIndex}
            showExpandBtn={showExpandBtn}
            expandFlag={expand}
            maxFlag={max}
            onDragMove={this.onDragMove.bind(this)}
            onExpand={this.onExpand.bind(this)}
        >
        </DragWidthCom>;
    }
}

CreateDragWidthCom.defaultProps = defaultProps;
CreateDragWidthCom.displayName = 'CreateDragWidthCom';
CreateDragWidthCom.useCreateDragWidthCom = useCreateDragWidthCom;

export default CreateDragWidthCom;
